import React, { useRef, useEffect, useState } from "react";
import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
  listAll,
  getMetadata,
  getStorage,
} from "firebase/storage";
import { storage } from "../../../../backend/firebaseConfig";
import "../../../../css/Recruitment/ApplicationSummary.css";
import JSZip from "jszip";
import { saveAs } from "file-saver";

const AdvisorFileModal = ({
  uid,
  files,
  isOpen,
  onClose,
  onFileUpload,
  onFileDelete,
  name,
}) => {
  const modalRef = useRef();
  const [selectedFiles, setSelectedFiles] = useState([]); // Allow multiple files
  const [isDownloading, setIsDownloading] = useState(false); // Track ZIP download state

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  useEffect(() => {
    // console.log(uid);
  }, [files]);

  const handleFileChange = (e) => {
    setSelectedFiles(Array.from(e.target.files)); // Store multiple files
  };

  const handleUpload = async () => {
    if (selectedFiles.length > 0 && uid) {
      const uploadedFiles = [];
      for (const file of selectedFiles) {
        const fileRef = ref(
          storage,
          `uploads/${uid}/ApplicationDetails/Admin/${file.name}`
        );
        try {
          await uploadBytes(fileRef, file);
          const fileURL = await getDownloadURL(fileRef);
          uploadedFiles.push({ name: file.name, url: fileURL });
        } catch (error) {
          // console.error("File upload error:", error);
        }
      }
      onFileUpload(uploadedFiles); // Pass all uploaded files to parent
      setSelectedFiles([]); // Reset file selection
      onClose();
    }
  };

  const handleRemoveSelectedFile = (index) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const handleDelete = async (file) => {
    if (!uid || !file.name) {
      // console.error("Missing UID or file name for deletion");
      return;
    }

    // Use the same storage path as upload
    const fileRef = ref(
      storage,
      `uploads/${uid}/ApplicationDetails/Admin/${file.name}`
    );
    try {
      await deleteObject(fileRef); // Delete file from Firebase Storage
      // Notify parent so it can update the file list
      onFileDelete(file);
    } catch (error) {
      // console.error("File delete error:", error);
    }
  };

const handleDownloadFiles = async () => {
  if (!files || files.length === 0) {
    // console.error("No files available for download.");
    return;
  }

  // console.log(`Downloading ${files.length} files...`);
  setIsDownloading(true);

  const zip = new JSZip();
  const folder = zip.folder("Supporting Documents");

  try {
    const downloadPromises = files.map(async (file) => {
      try {
        // Fetch files with CORS headers now enabled
        const response = await fetch(file.url);
        if (!response.ok) throw new Error(`Failed to fetch ${file.name}`);

        const blob = await response.blob();
        folder.file(file.name, blob);
        // console.log(`Added file: ${file.name}`);
      } catch (error) {
        // console.error(`Error fetching file ${file.name}:`, error);
      }
    });

    await Promise.all(downloadPromises);

    const zipBlob = await zip.generateAsync({ type: "blob" });
    saveAs(zipBlob, "Supporting Documents.zip");
    // console.log("ZIP file downloaded successfully!");
  } catch (error) {
    // console.error("Error creating ZIP:", error);
  } finally {
    setIsDownloading(false);
  }
};
//  const handleDownloadFiles = async () => {
//    if (!files || files.length === 0) {
//      console.error("No files available for download.");
//      return;
//    }

//    console.log(`Downloading ${files.length} files...`);
//    setIsDownloading(true);

//    try {
//      for (const file of files) {
//        try {
//          const response = await fetch(file.url, { mode: "no-cors" }); // Set no-cors mode
//          const blob = await response.blob();

//          const downloadLink = document.createElement("a");
//          downloadLink.href = URL.createObjectURL(blob);
//          downloadLink.download = file.name;
//          document.body.appendChild(downloadLink);
//          downloadLink.click();
//          document.body.removeChild(downloadLink);

//          console.log(`Downloaded file: ${file.name}`);
//        } catch (error) {
//          console.error(`Error downloading file ${file.name}:`, error);
//        }
//      }

//      console.log("All files downloaded successfully!");
//    } catch (error) {
//      console.error("Error during download process:", error);
//    } finally {
//      setIsDownloading(false);
//    }
//  };



  if (!isOpen) return null;

  return (
    <div className="file-modal-overlay">
      <div className="file-modal-content" ref={modalRef}>
        <h3>{name}</h3>
        <button className="close-button" onClick={onClose}>
          &times;
        </button>

        {/* Display already uploaded files */}
        {files.length > 0 ? (
          <ul>
            {files.map((file, index) => (
              <li key={index}>
                <a href={file.url} target="_blank" rel="noopener noreferrer">
                  {file.name}
                </a>
              </li>
            ))}
          </ul>
        ) : (
          <p>No files found.</p>
        )}

        <div className="file-upload-container">
          <input
            type="file"
            onChange={handleFileChange}
            multiple
            className="file-input"
            style={{ display: "none" }}
            id="fileInput"
          />
          <label htmlFor="fileInput">Click here to upload files</label>
        </div>

        {/* Display selected files with delete option */}
        {selectedFiles.length > 0 && (
          <div className="uploaded-files-list">
            <h4>Selected Files</h4>
            <ul>
              {selectedFiles.map((file, index) => (
                <li key={index}>
                  {file.name}
                  <button
                    type="button"
                    onClick={() => handleRemoveSelectedFile(index)}
                    className="icon-button delete-button"
                  >
                    <i className="fas fa-trash"></i>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
        <div className="button-container">
          <button
            className="submit-btn"
            onClick={handleUpload}
            disabled={selectedFiles.length === 0}
          >
            Upload
          </button>
          <button
            className="submit-btn"
            onClick={handleDownloadFiles}
            disabled={files.length === 0 || isDownloading}
          >
            {isDownloading ? "Downloading..." : "Download All"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdvisorFileModal;
